import packageJson from '/package.json';

export default function Versions(){

    const mui = packageJson.dependencies['@mui/icons-material']?.replace('^','');
    const npm = packageJson.dependencies?.npm?.replace('^','');
    const react = packageJson.dependencies?.react?.replace('^',''); // React.version
    const vite = packageJson.devDependencies?.vite?.replace('^','');
    const tailwind = packageJson.devDependencies?.tailwindcss?.replace('^','');
    const agGrid = packageJson.dependencies['@ag-grid-community/locale']?.replace('^','');
    const eslint = packageJson.devDependencies?.eslint?.replace('^','');

    const versions = [react,vite,npm,mui,tailwind,agGrid,eslint];
    const names = ['React','Vite','npm','MUI','TailwindCSS','AG Grid','eslint'];

    return (
        <div id='versions'>
        {
            versions && versions.length > 0 && versions.map((version,i) => (                
                <pre key={names[i]}>
                    {
                        version && version.length > 0 &&               
                        <><b>{names[i]}:</b> {version}<br/></>
                    }
                </pre>
            ))
        }
        </div>
    )
}